export enum CheckoutOptimizationUsagePricingMode {
  Flat = "flat",
  Qualifier = "qualifier",
}
